// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --calendar-day-height: 150rem;
  --calendar-edge-gutter: 0.7rem;
  display: block;
  height: 100%;
}

.resource-week-calendar {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

.day-header-row {
  display: grid;
  grid-template-columns: 3.5rem repeat(7, minmax(2.2rem, 1fr));
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #e5e5e5;
  background: #ffffff;
}

.time-header-spacer {
  border-right: 1px solid #eceef2;
}

.day-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  height: 4.25rem;
  padding-left: 0.4rem;
  border-right: 1px solid #dddddd;
  color: #111827;
  font-size: 1.05rem;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
}
.day-header strong {
  margin-top: 0.45rem;
  color: #111827;
  font-size: 1.05rem;
  font-weight: 400;
}
.day-header.emphasized {
  color: #111827;
}
.day-header.past:not(.emphasized) {
  color: #8b94a2;
  font-weight: 500;
}
.day-header.past:not(.emphasized) strong {
  color: #8b94a2;
  font-weight: 500;
}

.calendar-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.calendar-scroll::-webkit-scrollbar {
  display: none;
}

.week-swiper {
  display: block;
  min-height: calc(var(--calendar-day-height) + var(--calendar-edge-gutter) + var(--calendar-edge-gutter));
  touch-action: pan-y;
}

swiper-slide {
  height: calc(var(--calendar-day-height) + var(--calendar-edge-gutter) + var(--calendar-edge-gutter));
}

.calendar-body {
  position: relative;
  display: grid;
  grid-template-columns: 3.5rem minmax(0, 1fr);
  box-sizing: content-box;
  height: var(--calendar-day-height);
  padding-block: var(--calendar-edge-gutter);
}

.time-column {
  overflow: visible;
  border-right: 1px solid #eceef2;
  color: #111111;
  font-size: 0.9rem;
  font-weight: 600;
}

.time-row {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  height: 6rem;
  padding-right: 0.45rem;
  text-align: center;
}
.time-row span {
  position: absolute;
  top: 0;
  right: 0.45rem;
  transform: translateY(-50%);
  line-height: 1;
  white-space: nowrap;
}
.time-row.time-row--end-of-day {
  height: 0;
  overflow: visible;
}
.time-row.time-row--end-of-day span {
  top: 0;
  transform: translateY(-50%);
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(2.2rem, 1fr));
  height: var(--calendar-day-height);
  min-width: 0;
}

.day-column {
  position: relative;
  min-width: 0;
  border-right: 1px solid #f0f2f5;
  background-color: #ffffff;
  background-image: repeating-linear-gradient(to bottom, #d4d4d4 0, #d4d4d4 1px, transparent 1px, transparent 6rem);
}
.day-column::before {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: repeating-linear-gradient(to right, #d2d2d2 0, #d2d2d2 0.22rem, transparent 0.22rem, transparent 0.45rem);
  content: "";
  mask-image: repeating-linear-gradient(to bottom, transparent 0, transparent calc(3rem - 1px), #000 calc(3rem - 1px), #000 calc(3rem + 1px), transparent calc(3rem + 1px), transparent 6rem);
  -webkit-mask-image: repeating-linear-gradient(to bottom, transparent 0, transparent calc(3rem - 1px), #000 calc(3rem - 1px), #000 calc(3rem + 1px), transparent calc(3rem + 1px), transparent 6rem);
}
.day-column.off-hours {
  background-color: #e9e9e9;
}

.day-events {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  height: var(--calendar-day-height);
}

.day-shading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.03);
}

.slot-cell {
  position: absolute;
  right: 0;
  left: 0;
  height: 1.5rem;
  cursor: default;
  z-index: 1;
  touch-action: pan-y;
  -webkit-user-select: none;
  user-select: none;
}
.slot-cell.slot--available {
  cursor: pointer;
  transition: background 0.15s ease;
}
.slot-cell.slot--available:hover {
  background: rgba(237, 20, 61, 0.1);
}

.busy-slot {
  position: absolute;
  right: 0.03rem;
  left: 0.03rem;
  z-index: 5;
  box-sizing: border-box;
  overflow: hidden;
  min-height: 0.45rem;
  padding: 0.1rem 0.2rem;
  border-radius: 0;
  background: #ed143d;
  color: #ffffff;
  font-size: 0.63rem;
  line-height: 1.1;
}
.busy-slot::before {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.95) 0, rgba(255, 255, 255, 0.95) 1px, transparent 1px);
  background-position-y: var(--slot-grid-offset, 0);
  background-repeat: repeat;
  background-size: 100% 6rem;
  content: "";
}
.busy-slot::after {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: repeating-linear-gradient(to right, rgba(255, 255, 255, 0.75) 0, rgba(255, 255, 255, 0.75) 0.28rem, transparent 0.28rem, transparent 0.55rem);
  content: "";
  mask-image: linear-gradient(to bottom, transparent 0, transparent calc(3rem - 1px), #000 calc(3rem - 1px), #000 calc(3rem + 1px), transparent calc(3rem + 1px));
  mask-position: 0 var(--slot-grid-offset, 0);
  mask-repeat: repeat;
  mask-size: 100% 6rem;
  -webkit-mask-image: linear-gradient(to bottom, transparent 0, transparent calc(3rem - 1px), #000 calc(3rem - 1px), #000 calc(3rem + 1px), transparent calc(3rem + 1px));
  -webkit-mask-position: 0 var(--slot-grid-offset, 0);
  -webkit-mask-repeat: repeat;
  -webkit-mask-size: 100% 6rem;
}
.busy-slot span {
  display: none;
}
.busy-slot.past {
  background: #f47b96;
  color: #ffffff;
}

.current-time {
  position: absolute;
  right: 0;
  left: 0;
  z-index: 20;
  pointer-events: none;
}

.current-time-chip {
  position: absolute;
  top: -0.65rem;
  left: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  height: 1.3rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #e0061c;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
}

.current-time-line {
  position: absolute;
  top: 0;
  right: 0;
  left: 3.5rem;
  height: 1px;
  border-radius: 8px;
  background: #e0061c;
}

.calendar-loading {
  position: absolute;
  inset: 4.25rem 0 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.68);
}

.empty-week {
  position: absolute;
  top: 12rem;
  left: 50%;
  z-index: 12;
  max-width: min(16rem, 100% - 2rem);
  transform: translateX(-50%);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 4px 18px rgba(28, 35, 45, 0.1);
  color: #5f6876;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 0.55rem 0.8rem;
  text-align: center;
}

@media (max-width: 420px) {
  .day-header-row {
    grid-template-columns: 3rem repeat(7, minmax(1.9rem, 1fr));
  }
  .calendar-body {
    grid-template-columns: 3rem minmax(0, 1fr);
  }
  .days-grid {
    grid-template-columns: repeat(7, minmax(1.9rem, 1fr));
  }
  .time-column {
    font-size: 0.82rem;
  }
  .time-row {
    padding-right: 0.35rem;
  }
  .time-row span {
    right: 0.35rem;
  }
  .day-header {
    height: 3.6rem;
    font-size: 0.88rem;
  }
  .day-header strong {
    margin-top: 0.35rem;
    font-size: 0.88rem;
  }
  .current-time-chip {
    min-width: 2.45rem;
    font-size: 0.68rem;
  }
  .current-time-line {
    left: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/resource-availability/resource-week-calendar/resource-week-calendar.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,8BAAA;EAEA,cAAA;EACA,YAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,4DAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,+BAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;AAEE;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,cAAA;EACA,gBAAA;AAFJ;AAII;EACE,cAAA;EACA,gBAAA;AAFN;;AAOA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,iCAAA;EACA,qBAAA;AAJF;AAME;EACE,aAAA;AAJJ;;AAQA;EACE,cAAA;EACA,wGAAA;EAIA,mBAAA;AARF;;AAWA;EACE,oGAAA;AARF;;AAcA;EACE,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,uBAAA;EACA,kCAAA;EACA,0CAAA;AAXF;;AAcA;EACE,iBAAA;EACA,+BAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAXF;AAaE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AAXJ;AAcE;EACE,SAAA;EACA,iBAAA;AAZJ;AAcI;EACE,MAAA;EACA,2BAAA;AAZN;;AAiBA;EACE,aAAA;EACA,qDAAA;EACA,kCAAA;EACA,YAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;EACA,iHAAA;AAdF;AAsBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,qHAAA;EAOA,WAAA;EACA,2LAAA;EASA,mMAAA;AAlCJ;AA6CE;EACE,yBAAA;AA3CJ;;AA+CA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,kCAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;EACA,+BAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AA5CF;AA8CE;EACE,eAAA;EACA,iCAAA;AA5CJ;AA8CI;EACE,kCAAA;AA5CN;;AAkDA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA/CF;AAiDE;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,mHAAA;EAMA,iDAAA;EACA,yBAAA;EACA,0BAAA;EACA,WAAA;AApDJ;AAuDE;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,yJAAA;EAOA,WAAA;EACA,+JAAA;EAQA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,uKAAA;EAQA,mDAAA;EACA,2BAAA;EACA,4BAAA;AAzEJ;AA4EE;EACE,aAAA;AA1EJ;AA6EE;EACE,mBAAA;EACA,cAAA;AA3EJ;;AA+EA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qCAAA;EACA,4CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE;IACE,0DAAA;EA5EF;EA+EA;IACE,0CAAA;EA7EF;EAgFA;IACE,qDAAA;EA9EF;EAiFA;IACE,kBAAA;EA/EF;EAkFA;IACE,sBAAA;EAhFF;EAkFE;IACE,cAAA;EAhFJ;EAoFA;IACE,cAAA;IACA,kBAAA;EAlFF;EAoFE;IACE,mBAAA;IACA,kBAAA;EAlFJ;EAsFA;IACE,kBAAA;IACA,kBAAA;EApFF;EAuFA;IACE,UAAA;EArFF;AACF","sourcesContent":[":host {\n  --calendar-day-height: 150rem;\n  --calendar-edge-gutter: 0.7rem;\n\n  display: block;\n  height: 100%;\n}\n\n.resource-week-calendar {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n}\n\n.day-header-row {\n  display: grid;\n  grid-template-columns: 3.5rem repeat(7, minmax(2.2rem, 1fr));\n  border-top: 1px solid #f0f0f0;\n  border-bottom: 1px solid #e5e5e5;\n  background: #ffffff;\n}\n\n.time-header-spacer {\n  border-right: 1px solid #eceef2;\n}\n\n.day-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n  height: 4.25rem;\n  padding-left: 0.4rem;\n  border-right: 1px solid #dddddd;\n  color: #111827;\n  font-size: 1.05rem;\n  font-weight: 400;\n  line-height: 1.2;\n  text-align: left;\n\n  strong {\n    margin-top: 0.45rem;\n    color: #111827;\n    font-size: 1.05rem;\n    font-weight: 400;\n  }\n\n  &.emphasized {\n    color: #111827;\n  }\n\n  &.past:not(.emphasized) {\n    color: #8b94a2;\n    font-weight: 500;\n\n    strong {\n      color: #8b94a2;\n      font-weight: 500;\n    }\n  }\n}\n\n.calendar-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.week-swiper {\n  display: block;\n  min-height: calc(\n    var(--calendar-day-height) + var(--calendar-edge-gutter) +\n      var(--calendar-edge-gutter)\n  );\n  touch-action: pan-y;\n}\n\nswiper-slide {\n  height: calc(\n    var(--calendar-day-height) + var(--calendar-edge-gutter) +\n      var(--calendar-edge-gutter)\n  );\n}\n\n.calendar-body {\n  position: relative;\n  display: grid;\n  grid-template-columns: 3.5rem minmax(0, 1fr);\n  box-sizing: content-box;\n  height: var(--calendar-day-height);\n  padding-block: var(--calendar-edge-gutter);\n}\n\n.time-column {\n  overflow: visible;\n  border-right: 1px solid #eceef2;\n  color: #111111;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.time-row {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  height: 6rem;\n  padding-right: 0.45rem;\n  text-align: center;\n\n  span {\n    position: absolute;\n    top: 0;\n    right: 0.45rem;\n    transform: translateY(-50%);\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  &.time-row--end-of-day {\n    height: 0;\n    overflow: visible;\n\n    span {\n      top: 0;\n      transform: translateY(-50%);\n    }\n  }\n}\n\n.days-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(2.2rem, 1fr));\n  height: var(--calendar-day-height);\n  min-width: 0;\n}\n\n.day-column {\n  position: relative;\n  min-width: 0;\n  border-right: 1px solid #f0f2f5;\n  background-color: #ffffff;\n  background-image: repeating-linear-gradient(\n    to bottom,\n    #d4d4d4 0,\n    #d4d4d4 1px,\n    transparent 1px,\n    transparent 6rem\n  );\n\n  &::before {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    pointer-events: none;\n    background: repeating-linear-gradient(\n      to right,\n      #d2d2d2 0,\n      #d2d2d2 0.22rem,\n      transparent 0.22rem,\n      transparent 0.45rem\n    );\n    content: \"\";\n    mask-image: repeating-linear-gradient(\n      to bottom,\n      transparent 0,\n      transparent calc(3rem - 1px),\n      #000 calc(3rem - 1px),\n      #000 calc(3rem + 1px),\n      transparent calc(3rem + 1px),\n      transparent 6rem\n    );\n    -webkit-mask-image: repeating-linear-gradient(\n      to bottom,\n      transparent 0,\n      transparent calc(3rem - 1px),\n      #000 calc(3rem - 1px),\n      #000 calc(3rem + 1px),\n      transparent calc(3rem + 1px),\n      transparent 6rem\n    );\n  }\n\n  &.off-hours {\n    background-color: #e9e9e9;\n  }\n}\n\n.day-events {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  height: var(--calendar-day-height);\n}\n\n.day-shading {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.slot-cell {\n  position: absolute;\n  right: 0;\n  left: 0;\n  height: 1.5rem;\n  cursor: default;\n  z-index: 1;\n  touch-action: pan-y;\n  -webkit-user-select: none;\n  user-select: none;\n\n  &.slot--available {\n    cursor: pointer;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: rgba(237, 20, 61, 0.1);\n    }\n  }\n\n}\n\n.busy-slot {\n  position: absolute;\n  right: 0.03rem;\n  left: 0.03rem;\n  z-index: 5;\n  box-sizing: border-box;\n  overflow: hidden;\n  min-height: 0.45rem;\n  padding: 0.1rem 0.2rem;\n  border-radius: 0;\n  background: #ed143d;\n  color: #ffffff;\n  font-size: 0.63rem;\n  line-height: 1.1;\n\n  &::before {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    background: linear-gradient(\n      to bottom,\n      rgba(255, 255, 255, 0.95) 0,\n      rgba(255, 255, 255, 0.95) 1px,\n      transparent 1px\n    );\n    background-position-y: var(--slot-grid-offset, 0);\n    background-repeat: repeat;\n    background-size: 100% 6rem;\n    content: \"\";\n  }\n\n  &::after {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    background: repeating-linear-gradient(\n      to right,\n      rgba(255, 255, 255, 0.75) 0,\n      rgba(255, 255, 255, 0.75) 0.28rem,\n      transparent 0.28rem,\n      transparent 0.55rem\n    );\n    content: \"\";\n    mask-image: linear-gradient(\n      to bottom,\n      transparent 0,\n      transparent calc(3rem - 1px),\n      #000 calc(3rem - 1px),\n      #000 calc(3rem + 1px),\n      transparent calc(3rem + 1px)\n    );\n    mask-position: 0 var(--slot-grid-offset, 0);\n    mask-repeat: repeat;\n    mask-size: 100% 6rem;\n    -webkit-mask-image: linear-gradient(\n      to bottom,\n      transparent 0,\n      transparent calc(3rem - 1px),\n      #000 calc(3rem - 1px),\n      #000 calc(3rem + 1px),\n      transparent calc(3rem + 1px)\n    );\n    -webkit-mask-position: 0 var(--slot-grid-offset, 0);\n    -webkit-mask-repeat: repeat;\n    -webkit-mask-size: 100% 6rem;\n  }\n\n  span {\n    display: none;\n  }\n\n  &.past {\n    background: #f47b96;\n    color: #ffffff;\n  }\n}\n\n.current-time {\n  position: absolute;\n  right: 0;\n  left: 0;\n  z-index: 20;\n  pointer-events: none;\n}\n\n.current-time-chip {\n  position: absolute;\n  top: -0.65rem;\n  left: 0.15rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.75rem;\n  height: 1.3rem;\n  padding: 0 0.35rem;\n  border-radius: 999px;\n  background: #e0061c;\n  color: #ffffff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.current-time-line {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 3.5rem;\n  height: 1px;\n  border-radius: 8px;\n  background: #e0061c;\n}\n\n.calendar-loading {\n  position: absolute;\n  inset: 4.25rem 0 0;\n  z-index: 30;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.68);\n}\n\n.empty-week {\n  position: absolute;\n  top: 12rem;\n  left: 50%;\n  z-index: 12;\n  max-width: min(16rem, calc(100% - 2rem));\n  transform: translateX(-50%);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 4px 18px rgba(28, 35, 45, 0.1);\n  color: #5f6876;\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.2;\n  padding: 0.55rem 0.8rem;\n  text-align: center;\n}\n\n@media (max-width: 420px) {\n  .day-header-row {\n    grid-template-columns: 3rem repeat(7, minmax(1.9rem, 1fr));\n  }\n\n  .calendar-body {\n    grid-template-columns: 3rem minmax(0, 1fr);\n  }\n\n  .days-grid {\n    grid-template-columns: repeat(7, minmax(1.9rem, 1fr));\n  }\n\n  .time-column {\n    font-size: 0.82rem;\n  }\n\n  .time-row {\n    padding-right: 0.35rem;\n\n    span {\n      right: 0.35rem;\n    }\n  }\n\n  .day-header {\n    height: 3.6rem;\n    font-size: 0.88rem;\n\n    strong {\n      margin-top: 0.35rem;\n      font-size: 0.88rem;\n    }\n  }\n\n  .current-time-chip {\n    min-width: 2.45rem;\n    font-size: 0.68rem;\n  }\n\n  .current-time-line {\n    left: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
